"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {OnlyImageBgCard, PaveScaleCard} from "@/components/common/pave-scale-card";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Pôle de l’Observation et des Etudes"} description={"L’approche du tourisme est économique et sous cet angle, le tourisme s’entend des activités des personnes appelées visiteurs."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <p className={"text-normal text-justify"}>


                  L’information est au cœur de l’écosystème numérique touristique. Elle nourrit les stratégies des destinations, alimente les démarches et enrichit les outils de connaissances et d’aide à la décision.
<br/>
<br/>
                  Mettre la data en mouvement !
                  <br/>
                  <br/>
                  Avec comme enjeux stratégiques d’enrichir la connaissance et développer les outils d’aide à la décision et d’élargir le champ d’analyse économique du tourisme.

              </p>
          </SectionPage>

              <SectionPage sectionType="lg">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 mb-6">
                      <PaveScaleCard title={"Observatoire de l'Activité Touristique en Côte d'Ivoire"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-civ" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/pole-observation-etudes/img1.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Observatoire de l'Activité Touristique dans le Monde"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-monde" titleClassName={"font-playfair-display italic font-bold"} />
                      <PaveScaleCard title={"Réglémentation"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/pole-observation-etudes/reglementation" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/pole-observation-etudes/img2.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Veille"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/pole-observation-etudes/veille" titleClassName={"font-playfair-display italic font-bold"} />
                  </div>
              </SectionPage>

        </div>
  );
}
